// import saga stuff
import { takeEvery, put, call, all } from "redux-saga/effects";

import {
  GET_CONTRACT_LIST,
  GET_CONTRACT_STATUS_LIST,
  GET_SINGLE_CONTRACT_ITEM,
  UPDATE_CONTRACT_ITEM,
  DELETE_CONTRACT_ITEMS,
  SINGLE_CUSTOMER_SEARCH_CONTRACTS,
  GET_CONTRACT_ITEMS_LIST,
  GET_CONTRACT_ITEMS_STATUS_LIST,
  GET_CONTRACT_UNIT_FREQUENCY_LIST,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST,
  CREATE_CONTRACT_WITH_ITEMS,
  GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY,
  UPDATE_CONTRACT_WITH_ITEMS,
  PREVIEW_CONTRACT_UPDATE,
  PREVIEW_CONTRACT_CREATE,
  GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST,
  DELETE_SINGLE_CONTRACT_ITEM,
  GET_CONTRACT_ITEMS_ACTIVE_LIST,
  GET_CONTRACT_ITEMS_CANCELLED_LIST,
  GET_CONTRACT_ITEM_USAGE_SEARCH_LIST,
  GET_CONTRACT_ITEM_USAGE_LIST,
  GET_CONTRACT_ITEM_USAGE_SEARCH,
  SEARCH_CONTRACT_PDF,
  DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE,
  GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF,
  GENERATE_CONTRACT_ITEM_USAGE,
  GET_CONTRACT_ITEM_USAGE_PDF,
  REGENERATE_CONTRACT_ITEM_USAGE_PDF,
  GET_CONTRACT_ITEM_CREDIT_LIST,
  CREATE_CONTRACT_ITEM_CREDIT,
  UPDATE_CONTRACT_ITEM_CREDIT,
  DELETE_CONTRACT_ITEM_CREDIT,
  GET_CONTRACT_ITEM_PORTFOLIO,
  GET_CONTRACT_ITEM_DEBIT_LIST,
  GET_JOB_LIST_BY_CONTRACT_ITEM,
} from "./actionType";

import {
  getContractListSuccess,
  getContractListFailure,
  getContractStatusListSuccess,
  getContractStatusListFailure,
  getSingleContractItemSuccess,
  getSingleContractItemFailure,
  updateContractItemSuccess,
  updateContractItemFailure,
  deleteContractItemsSuccess,
  deleteContractItemsFailure,
  singleCustomerSearchContractsSuccess,
  singleCustomerSearchContractsFailure,
  getContractItemsListSuccess,
  getContractItemsListFailure,
  getContractItemsStatusListSuccess,
  getContractItemsStatusListFailure,
  getContractUnitFrequencyListSuccess,
  getContractUnitFrequencyListFailure,
  searchSingleCustomerContractItemListSuccess,
  searchSingleCustomerContractItemListFailure,
  createContractWithItemsSuccess,
  createContractWithItemsFailure,
  searchSingleCustomerContractItemSummaryListSuccess,
  searchSingleCustomerContractItemSummaryListFailure,
  updateContractWithItemsSuccess,
  updateContractWithItemsFailure,
  previewContractUpdateSuccess,
  previewContractUpdateFailure,
  previewContractCreateSuccess,
  previewContractCreateFailure,
  getContractItemRenewalFrequencyListSuccess,
  getContractItemRenewalFrequencyListFailure,
  deleteSingleContractItemSuccess,
  deleteSingleContractItemFailure,
  getContractItemsActiveListSuccess,
  getContractItemsActiveListFailure,
  getContractItemsCancelledListSuccess,
  getContractItemsCancelledListFailure,
  getContractItemUsageSearchListSuccess,
  getContractItemUsageSearchListFailure,
  getContractItemUsageListSuccess,
  getContractItemUsageListFailure,
  getContractItemUsageSearchSuccess,
  getContractItemUsageSearchFailure,
  searchContractPdfSuccess,
  searchContractPdfFailure,
  deleteAllPreviousContractItemUsageSuccess,
  deleteAllPreviousContractItemUsageFailure,
    getContractItemUsageLiveBalancePdfSuccess,
    getContractItemUsageLiveBalancePdfFailure,
  generateContractItemUsageSuccess,
  generateContractItemUsageFailure,
  getContractItemUsagePdfSuccess,
  getContractItemUsagePdfFailure,
  regenerateContractItemUsagePdfSuccess,
  regenerateContractItemUsagePdfFailure,
  getContractItemCreditListSuccess,
  getContractItemCreditListFailure,
  createContractItemCreditSuccess,
  createContractItemCreditFailure,
  updateContractItemCreditSuccess,
  updateContractItemCreditFailure,
  deleteContractItemCreditSuccess,
  deleteContractItemCreditFailure,
  getContractItemPortfolioSuccess,
  getContractItemPortfolioFailure,
  getContractItemDebitListSuccess,
  getContractItemDebitListFailure,
  getJobListByContractItemSuccess,
  getJobListByContractItemFailure,
} from "./action";

// import api

import {
  getContractListApiCall,
  getContractStatusListApiCall,
  getContractSingleContractDataApiCall,
  updateSingleContractApiCall,
  deleteContractApiCall,
  searchSingleCustomerContractApiCall,
  getContractItemsListApiCall,
  getContractItemsStatusListApiCall,
  getContractFrequencyListApiCall,
  searchSingleCustomerContractItemListApiCall,
  createContractWithItemsApiCall,
  searchSingleCustomerContractItemSummaryListApiCall,
  updateContractWithItemsApiCall,
  previewContractUpdateApiCall,
  previewContractCreateApiCall,
  getContractItemRenewalFrequencyListApiCall,
  deleteSingleContractItemApiCall,
  getContractItemsActiveListApiCall,
  getContractItemsCancelledListApiCall,
  getContractItemUsageSearchListApiCall,
  getContractItemUsageListApiCall,
  getContractItemUsageSearchApiCall,
  searchContractPdfApiCall,
  deleteAllPreviousContractItemUsageApiCall,
  getContractItemUsageLiveBalancePdfApiCall,
  generateContractItemUsageApiCall,
  getContractItemUsagePdfApiCall,
  regenerateContractItemUsagePdfApiCall,
  getContractItemCreditListApiCall,
  createContractItemCreditApiCall,
  updateContractItemCreditApiCall,
  deleteContractItemCreditApiCall,
  getContractItemPortfolioApiCall,
  getContractItemDebitListApiCall,
  getJobListByContractItemApiCall,
} from "../../helpers/fakebackend_helper";

// Get Contract List
function* getContractListApi() {
  try {
    const response = yield call(getContractListApiCall);
    yield put(getContractListSuccess(response));
  } catch (error) {
    yield put(getContractListFailure(error));
  }
}

// Watcher Saga
export function* contractWatcherSaga() {
  yield all([takeEvery(GET_CONTRACT_LIST, getContractListApi)]);
}

// Create Contract Item

// watcherContractCreate Saga

// Get Contract Status List
function* getContractStatusListApi() {
  try {
    const response = yield call(getContractStatusListApiCall);
    yield put(getContractStatusListSuccess(response));
  } catch (error) {
    yield put(getContractStatusListFailure(error));
  }
}

// Watcher
export function* contractStatusWatcherSaga() {
  yield takeEvery(GET_CONTRACT_STATUS_LIST, getContractStatusListApi);
}
// Get Single Contract Item
function* getSingleContractItemApi(action) {
  try {
    const response = yield call(
      getContractSingleContractDataApiCall,
      action.payload
    );
    yield put(getSingleContractItemSuccess(response));
  } catch (error) {
    yield put(getSingleContractItemFailure(error));
  }
}

// Watcher
export function* watcherGetSingleContractItem() {
  yield takeEvery(GET_SINGLE_CONTRACT_ITEM, getSingleContractItemApi);
}

// Update Contract Item

function* updateContractItemApi(action) {
  try {
    const response = yield call(updateSingleContractApiCall, action.payload);
    yield put(updateContractItemSuccess(response));
  } catch (error) {
    yield put(updateContractItemFailure(error));
  }
}

// watcherContractCreate Saga
export function* watcherUpdateContractItem() {
  yield takeEvery(UPDATE_CONTRACT_ITEM, updateContractItemApi);
}

// Delete Contract Item

function* deleteContractItemsApi(action) {
  try {
    const response = yield call(deleteContractApiCall, action.payload);
    yield put(deleteContractItemsSuccess(response));
  } catch (error) {
    yield put(deleteContractItemsFailure(error));
  }
}

// watcherContractCreate Saga

export function* watcherDeleteContractItems() {
  yield takeEvery(DELETE_CONTRACT_ITEMS, deleteContractItemsApi);
}

// Single Customer Search Contracts

function* singleCustomerSearchContractsApi(action) {
  try {
    const response = yield call(
      searchSingleCustomerContractApiCall,
      action.payload
    );
    yield put(singleCustomerSearchContractsSuccess(response));
  } catch (error) {
    yield put(singleCustomerSearchContractsFailure(error));
  }
}

// watcherContractCreate Saga

export function* watcherSingleCustomerSearchContracts() {
  yield takeEvery(
    SINGLE_CUSTOMER_SEARCH_CONTRACTS,
    singleCustomerSearchContractsApi
  );
}

// Get Contract Items List
function* getContractItemsListApi(action) {
  try {
    const response = yield call(getContractItemsListApiCall, action.payload);
    yield put(getContractItemsListSuccess(response));
  } catch (error) {
    yield put(getContractItemsListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemsList() {
  yield takeEvery(GET_CONTRACT_ITEMS_LIST, getContractItemsListApi);
}

// Get Contract Items Status List
function* getContractItemsStatusListApi() {
  try {
    const response = yield call(getContractItemsStatusListApiCall);
    yield put(getContractItemsStatusListSuccess(response));
  } catch (error) {
    yield put(getContractItemsStatusListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemsStatusList() {
  yield takeEvery(
    GET_CONTRACT_ITEMS_STATUS_LIST,
    getContractItemsStatusListApi
  );
}

// Get Contract Unit Frequency List
function* getContractUnitFrequencyListApi() {
  try {
    const response = yield call(getContractFrequencyListApiCall);
    yield put(getContractUnitFrequencyListSuccess(response));
  } catch (error) {
    yield put(getContractUnitFrequencyListFailure(error));
  }
}

// Watcher

export function* watcherGetContractUnitFrequencyList() {
  yield takeEvery(
    GET_CONTRACT_UNIT_FREQUENCY_LIST,
    getContractUnitFrequencyListApi
  );
}

// Search Single Customer Contract Item List
function* searchSingleCustomerContractItemListApi(action) {
  try {
    const response = yield call(
      searchSingleCustomerContractItemListApiCall,
      action.payload
    );
    yield put(searchSingleCustomerContractItemListSuccess(response));
  } catch (error) {
    yield put(searchSingleCustomerContractItemListFailure(error));
  }
}

// watcher Single Customer Contract Item List Saga

export function* watcherSearchSingleCustomerContractItemList() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST,
    searchSingleCustomerContractItemListApi
  );
}

// Create Contract With Items
function* createContractWithItemsApi(action) {
  try {
    const response = yield call(createContractWithItemsApiCall, action.payload);
    yield put(createContractWithItemsSuccess(response));
  } catch (error) {
    yield put(createContractWithItemsFailure(error));
  }
}

// watcherContractCreate Saga
export function* watcherContractCreateWithItems() {
  yield takeEvery(CREATE_CONTRACT_WITH_ITEMS, createContractWithItemsApi);
}

// Single Customer Contract Item Summary List
function* singleCustomerContractItemSummaryListApi(action) {
  try {
    const response = yield call(
      searchSingleCustomerContractItemSummaryListApiCall,
      action.payload
    );
    yield put(searchSingleCustomerContractItemSummaryListSuccess(response));
  } catch (error) {
    yield put(searchSingleCustomerContractItemSummaryListFailure(error));
  }
}

// watcher Single Customer Contract Item Summary List Saga

export function* watcherSingleCustomerContractItemSummaryList() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY,
    singleCustomerContractItemSummaryListApi
  );
}

// update Contract With Items Api
function* updateContractWithItemsApi(action) {
  try {
    const response = yield call(updateContractWithItemsApiCall, action.payload);
    yield put(updateContractWithItemsSuccess(response));
  } catch (error) {
    yield put(updateContractWithItemsFailure(error));
  }
}

// watcherContractCreate Saga
export function* watcherUpdateContractWithItems() {
  yield takeEvery(UPDATE_CONTRACT_WITH_ITEMS, updateContractWithItemsApi);
}

// Preview Contract Update Api (dry-run)
function* previewContractUpdateApi(action) {
  try {
    const response = yield call(previewContractUpdateApiCall, action.payload);
    yield put(previewContractUpdateSuccess(response));
  } catch (error) {
    yield put(previewContractUpdateFailure(error));
  }
}

// watcher Preview Contract Update Saga
export function* watcherPreviewContractUpdate() {
  yield takeEvery(PREVIEW_CONTRACT_UPDATE, previewContractUpdateApi);
}

// Preview Contract Create Api (dry-run)
function* previewContractCreateApi(action) {
  try {
    const response = yield call(previewContractCreateApiCall, action.payload);
    yield put(previewContractCreateSuccess(response));
  } catch (error) {
    yield put(previewContractCreateFailure(error));
  }
}

// watcher Preview Contract Create Saga
export function* watcherPreviewContractCreate() {
  yield takeEvery(PREVIEW_CONTRACT_CREATE, previewContractCreateApi);
}

// Get Contract item Request frequency List
function* getContractItemRequestFrequencyListApi() {
  try {
    const response = yield call(getContractItemRenewalFrequencyListApiCall);
    yield put(getContractItemRenewalFrequencyListSuccess(response));
  } catch (error) {
    yield put(getContractItemRenewalFrequencyListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemRequestFrequencyList() {
  yield takeEvery(
    GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST,
    getContractItemRequestFrequencyListApi
  );
}

// Delete Single Contract Item
function* deleteSingleContractItemApi(action) {
  try {
    const response = yield call(
      deleteSingleContractItemApiCall,
      action.payload
    );
    yield put(deleteSingleContractItemSuccess(response));
  } catch (error) {
    yield put(deleteSingleContractItemFailure(error));
  }
}

// watcherContractCreate Saga

export function* watcherDeleteSingleContractItem() {
  yield takeEvery(DELETE_SINGLE_CONTRACT_ITEM, deleteSingleContractItemApi);
}

// Get Contract Items Active List
function* getContractItemsActiveListApi() {
  try {
    const response = yield call(getContractItemsActiveListApiCall);
    yield put(getContractItemsActiveListSuccess(response));
  } catch (error) {
    yield put(getContractItemsActiveListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemsActiveList() {
  yield takeEvery(
    GET_CONTRACT_ITEMS_ACTIVE_LIST,
    getContractItemsActiveListApi
  );
}

// Get Contract Items Cancelled List
function* getContractItemsCancelledListApi() {
  try {
    const response = yield call(getContractItemsCancelledListApiCall);
    yield put(getContractItemsCancelledListSuccess(response));
  } catch (error) {
    yield put(getContractItemsCancelledListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemsCancelledList() {
  yield takeEvery(
    GET_CONTRACT_ITEMS_CANCELLED_LIST,
    getContractItemsCancelledListApi
  );
}

// Get Contract Item Usage Search List
function* getContractItemUsageSearchListApi(action) {
  try {
    const response = yield call(
      getContractItemUsageSearchListApiCall,
      action.payload
    );
    yield put(getContractItemUsageSearchListSuccess(response));
  } catch (error) {
    yield put(getContractItemUsageSearchListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemUsageSearchList() {
  yield takeEvery(
    GET_CONTRACT_ITEM_USAGE_SEARCH_LIST,
    getContractItemUsageSearchListApi
  );
}

// Get Contract Item Usage List
function* getContractItemUsageListApi() {
  try {
    const response = yield call(getContractItemUsageListApiCall);
    yield put(getContractItemUsageListSuccess(response));
  } catch (error) {
    yield put(getContractItemUsageListFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemUsageList() {
  yield takeEvery(GET_CONTRACT_ITEM_USAGE_LIST, getContractItemUsageListApi);
}

// Get Contract Item Usage Search
function* getContractItemUsageSearchApi(action) {
  try {
    const response = yield call(
      getContractItemUsageSearchApiCall,
      action.payload
    );
    yield put(getContractItemUsageSearchSuccess(response));
  } catch (error) {
    yield put(getContractItemUsageSearchFailure(error));
  }
}

// Watcher

export function* watcherGetContractItemUsageSearch() {
  yield takeEvery(
    GET_CONTRACT_ITEM_USAGE_SEARCH,
    getContractItemUsageSearchApi
  );
}

// Search Contract Pdf
function* searchContractPdfApi(action) {
  try {
    const response = yield call(searchContractPdfApiCall, action.payload);
    yield put(searchContractPdfSuccess(response));
  } catch (error) {
    yield put(searchContractPdfFailure(error));
  }
}

// Watcher

export function* watcherSearchContractPdf() {
  yield takeEvery(SEARCH_CONTRACT_PDF, searchContractPdfApi);
}

// Delete All Previous Contract Item Usage
function* deleteAllPreviousContractItemUsageApi(action) {
  try {
    const response = yield call(
      deleteAllPreviousContractItemUsageApiCall,
      action.payload
    );
    yield put(deleteAllPreviousContractItemUsageSuccess(response));
  } catch (error) {
    yield put(deleteAllPreviousContractItemUsageFailure(error));
  }
}

// watcherContractCreate Saga

export function* watcherDeleteAllPreviousContractItemUsage() {
  yield takeEvery(
    DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE,
    deleteAllPreviousContractItemUsageApi
  );
}

// Get Contract Item Usage Live Balance Pdf
function* getContractItemUsageLiveBalancePdfApi(action) {
  try {
    const response = yield call(
      getContractItemUsageLiveBalancePdfApiCall,
      action.payload
    );
    yield put(getContractItemUsageLiveBalancePdfSuccess(response));
  } catch (error) {
    yield put(getContractItemUsageLiveBalancePdfFailure(error));
  }
}

// Watcher
export function* watcherGetContractItemUsageLiveBalancePdf() {
  yield takeEvery(
    GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF,
    getContractItemUsageLiveBalancePdfApi
  );
}

// Generate Contract Item Usage Statement (on demand)
function* generateContractItemUsageApi(action) {
  try {
    const response = yield call(generateContractItemUsageApiCall, action.payload);
    yield put(generateContractItemUsageSuccess(response));
  } catch (error) {
    yield put(generateContractItemUsageFailure(error));
  }
}
export function* watcherGenerateContractItemUsage() {
  yield takeEvery(GENERATE_CONTRACT_ITEM_USAGE, generateContractItemUsageApi);
}

// Get single Contract Item Usage statement PDF
function* getContractItemUsagePdfApi(action) {
  try {
    const response = yield call(getContractItemUsagePdfApiCall, action.payload);
    yield put(getContractItemUsagePdfSuccess(response));
  } catch (error) {
    yield put(getContractItemUsagePdfFailure(error));
  }
}
export function* watcherGetContractItemUsagePdf() {
  yield takeEvery(GET_CONTRACT_ITEM_USAGE_PDF, getContractItemUsagePdfApi);
}

// Regenerate a single Contract Item Usage statement PDF (into the new design)
function* regenerateContractItemUsagePdfApi(action) {
  try {
    const response = yield call(
      regenerateContractItemUsagePdfApiCall,
      action.payload
    );
    yield put(regenerateContractItemUsagePdfSuccess(response));
  } catch (error) {
    yield put(regenerateContractItemUsagePdfFailure(error));
  }
}
export function* watcherRegenerateContractItemUsagePdf() {
  yield takeEvery(
    REGENERATE_CONTRACT_ITEM_USAGE_PDF,
    regenerateContractItemUsagePdfApi
  );
}

// Get Contract Item Credit List
function* getContractItemCreditListApi(action) {
  try {
    const response = yield call(getContractItemCreditListApiCall, action.payload);
    yield put(getContractItemCreditListSuccess(response));
  } catch (error) {
    yield put(getContractItemCreditListFailure(error));
  }
}
export function* watcherGetContractItemCreditList() {
  yield takeEvery(GET_CONTRACT_ITEM_CREDIT_LIST, getContractItemCreditListApi);
}

// Create Contract Item Credit (manual)
function* createContractItemCreditApi(action) {
  try {
    const response = yield call(createContractItemCreditApiCall, action.payload);
    yield put(createContractItemCreditSuccess(response));
  } catch (error) {
    yield put(createContractItemCreditFailure(error));
  }
}
export function* watcherCreateContractItemCredit() {
  yield takeEvery(CREATE_CONTRACT_ITEM_CREDIT, createContractItemCreditApi);
}

// Update Contract Item Credit
function* updateContractItemCreditApi(action) {
  try {
    const response = yield call(updateContractItemCreditApiCall, action.payload);
    yield put(updateContractItemCreditSuccess(response));
  } catch (error) {
    yield put(updateContractItemCreditFailure(error));
  }
}
export function* watcherUpdateContractItemCredit() {
  yield takeEvery(UPDATE_CONTRACT_ITEM_CREDIT, updateContractItemCreditApi);
}

// Delete Contract Item Credit
function* deleteContractItemCreditApi(action) {
  try {
    const response = yield call(deleteContractItemCreditApiCall, action.payload);
    yield put(deleteContractItemCreditSuccess(response));
  } catch (error) {
    yield put(deleteContractItemCreditFailure(error));
  }
}
export function* watcherDeleteContractItemCredit() {
  yield takeEvery(DELETE_CONTRACT_ITEM_CREDIT, deleteContractItemCreditApi);
}

// Get Time-Tracked Contract Item Portfolio
function* getContractItemPortfolioApi() {
  try {
    const response = yield call(getContractItemPortfolioApiCall);
    yield put(getContractItemPortfolioSuccess(response));
  } catch (error) {
    yield put(getContractItemPortfolioFailure(error));
  }
}
export function* watcherGetContractItemPortfolio() {
  yield takeEvery(GET_CONTRACT_ITEM_PORTFOLIO, getContractItemPortfolioApi);
}

// Get Contract Item Debit List
function* getContractItemDebitListApi(action) {
  try {
    const response = yield call(getContractItemDebitListApiCall, action.payload);
    yield put(getContractItemDebitListSuccess(response));
  } catch (error) {
    yield put(getContractItemDebitListFailure(error));
  }
}
export function* watcherGetContractItemDebitList() {
  yield takeEvery(GET_CONTRACT_ITEM_DEBIT_LIST, getContractItemDebitListApi);
}

// Get Job List By Contract Item
function* getJobListByContractItemApi(action) {
  try {
    const response = yield call(getJobListByContractItemApiCall, action.payload);
    yield put(getJobListByContractItemSuccess(response));
  } catch (error) {
    yield put(getJobListByContractItemFailure(error));
  }
}
export function* watcherGetJobListByContractItem() {
  yield takeEvery(GET_JOB_LIST_BY_CONTRACT_ITEM, getJobListByContractItemApi);
}



// Root Saga
function* Contract() {
  yield all([
    contractWatcherSaga(),
    contractStatusWatcherSaga(),
    watcherGetSingleContractItem(),
    watcherUpdateContractItem(),
    watcherDeleteContractItems(),
    watcherSingleCustomerSearchContracts(),
    watcherGetContractItemsList(),
    watcherGetContractItemsStatusList(),
    watcherGetContractUnitFrequencyList(),
    watcherSearchSingleCustomerContractItemList(),
    watcherContractCreateWithItems(),
    watcherSingleCustomerContractItemSummaryList(),
    watcherUpdateContractWithItems(),
    watcherPreviewContractUpdate(),
    watcherPreviewContractCreate(),
    watcherGetContractItemRequestFrequencyList(),
    watcherDeleteSingleContractItem(),
    watcherGetContractItemsActiveList(),
    watcherGetContractItemsCancelledList(),
    watcherGetContractItemUsageSearchList(),
    watcherGetContractItemUsageList(),
    watcherGetContractItemUsageSearch(),
    watcherSearchContractPdf(),
    watcherDeleteAllPreviousContractItemUsage(),
    watcherGetContractItemUsageLiveBalancePdf(),
    watcherGenerateContractItemUsage(),
    watcherGetContractItemUsagePdf(),
    watcherRegenerateContractItemUsagePdf(),
    watcherGetContractItemCreditList(),
    watcherCreateContractItemCredit(),
    watcherUpdateContractItemCredit(),
    watcherDeleteContractItemCredit(),
    watcherGetContractItemPortfolio(),
    watcherGetContractItemDebitList(),
    watcherGetJobListByContractItem(),
  ]);
}

export default Contract;
